import { defineComponent, ref, computed, onMounted } from 'vue';
import LocalizedInfoSection from './localizedInfoSection.vue';
import Layout from './layout.vue';
import { ESignCommonClient, InfoPageDetails } from './esignclient';

import { useI18n } from '@/i18n-shim'

export default defineComponent({
  name: 'InfoView',
  props: {
    tenantId: {
      type: String,
      required: true
    }
  },
  components: {
    localizedInfoSection: LocalizedInfoSection,
    layout: Layout
  },
  setup(props) {
    const infoPageDetails = ref(null as InfoPageDetails | null);

    onMounted(async () => {
      infoPageDetails.value = await getInfoPageDetails();
    });

    async function getInfoPageDetails() {
      const commonClient = new ESignCommonClient();
      return await commonClient.getTenantInfoPageDetails(props.tenantId);
    }
    const i18n = useI18n();
    return {
      accessibilityStatementUrl: computed(() =>
        `/saavutettavuus/${props.tenantId}?lang=${i18n.locale.value}`
      ),
      infoPageDetails,
      ...i18n
    }
  }
});
